//
export default [
  {
      text: "Folio ND",
      value: "number",
  },
  // {
  //     text: "Cliente",
  //     value: "sl_customer_business_name",
  // },
  {
      text: "Fecha de emisión",
      value: "emission_date",
      align: "right",
      format: "date",
  },
  {
     text: "Documento Ref",
     value: "typeDocumentReference",
     align: "right",
  },
  {
      text: "Folio Ref",
      value: "referenced_dte_number",
      align: "right",
  },
  {
      text: "Neto",
      value: "net_total",
      align: "right",
      format: "currency",
  },
  {
      text: "Iva",
      value: "iva",
      align: "right",
      format: "currency",
  },
  {
      text: "Total",
      value: "total",
      align: "right",
      format: "currency",
  },
]